<template>
  <bg-image :effect="{ type: 'zoom-out', threshold: 0.5 }" :src="background" class="overlay-gradient position-sticky about-carousel-bg mt-3"></bg-image>

  <div class="about-carousel-wrapper">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-13">
          <p class="xxl-display-3 display-5 mb-5">what we do</p>

          <div class="about-carousel-slider">
            <div v-for="(slide, index) in slides" class="about-carousel-slide">
              <div class="title-part">
                <p class="part"><span>{{ index + 1 }}</span>/{{ slides.length }}</p>
                <p class="xxl-h5 xxlarge ff-sans-2">{{ slide.title }}</p>
              </div>

              <hr class="secondary thick tiny mx-0 my-2">

              <div v-html="slide.text" class="xxl-normal xsmall"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  slides: {
    type: Array,
    default: null,
    required: true
  },
  background: {
    type: String,
    default: null,
    required: false
  },
});

///////////////////////////////////////////////////////////// Gsap animation
import { onMounted } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

onMounted(() => {

  gsap.to(".about-carousel-slider", {
    scrollTrigger: {
      trigger: ".about-carousel-slide",
      start: "0% 95%",
      end: "0% 95%",
      toggleActions: "play none reverse none",
      // markers: true
    },
    opacity: 1,
    y: 0,
  })

  const slides = gsap.utils.toArray(".about-carousel-slide");

  slides.forEach(slide => {
    gsap.to(slide, {
      scrollTrigger: {
        trigger: slide,
        start: "0% 65%",
        end: "100% 65%",
        toggleActions: "play reverse play reverse",
        // markers: true
      },
      opacity: 1,
    })
  });
});

</script>

<style lang="scss">
@import '../sass/variables';

.about-carousel-bg {
  height: 100vh;
}

.about-carousel-wrapper {
  position: relative;
  z-index: 1;
  margin-top: -90vh;
  padding-bottom: 500px;
}

.about-carousel-slider {
  opacity: 0;
  transform: translateY(100px);
}


// SM (576px)
@media only screen and (min-width: map-get($grid-breakpoints, "sm")) {
  .about-carousel-wrapper {
    margin-top: -60vh;
  }
}

// MD (768px)
// @media only screen and (min-width: map-get($grid-breakpoints, "md")) {}

// LG (992px)
// @media only screen and (min-width: map-get($grid-breakpoints, "lg")) {}

// XL (1200px)
// @media only screen and (min-width: map-get($grid-breakpoints, "xl")) {}

// XXL (1367px)
// @media only screen and (min-width: map-get($grid-breakpoints, "xxl")) {}</style>